export default sec => {
	const items = ["day", "hour", "min", "sec"],
		units = [86400, 3600, 60, 1],
		len = units.length;
	let value,
		i = 0,
		str = "";
	for (; i < len; i += 1) {
		value = Math.floor(sec / units[i]);
		if (value) {
			str += (str === "" ? "" : ", ") + value + " " + items[i] + (value > 1 ? "s" : "");
			sec = sec % units[i];
			if (!sec) {
				break;
			}
		}
	}
	return str;
};
